// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".sop_dialog[data-v-59e787f5]  .el-dialog--center {\n  text-align: left !important;\n}\n.sop_dialog[data-v-59e787f5]  .el-dialog__title {\n  font-weight: 700;\n  font-size: 17px;\n}\n.sop_dialog[data-v-59e787f5]  .el-table__header .el-table__cell .cell {\n  font-weight: bold;\n  font-size: 15px;\n  color: #000;\n}", ""]);
// Exports
module.exports = exports;
